import { africa } from './africa'
import { americas } from './americas'
import { asia } from './asia'
import { europe } from './europe'
import { oceania } from './oceania'
import { antarctic } from './antarctic'

const world = [
  ...africa,
  ...americas,
  ...asia,
  ...europe,
  ...oceania,
  ...antarctic
]

export const regions = {
  world,
  africa,
  americas,
  asia,
  europe,
  oceania,
  antarctic
}

export const getRegionCountries = (filter) => regions[filter] || regions.world
